module.exports = __webpack_public_path__ + "h5/img/cs_20.0b0caae9.jpeg";